module.exports = __webpack_public_path__ + "img/logo.fd13239e.png";